export default function Marquee({ items = [] }) {
  if (!items.length) return null;
  const loop = [...items, ...items];
  return (
    <div className="relative w-full overflow-hidden border-y border-hairline/60 bg-ink py-6" data-testid="slogan-marquee">
      <div className="marquee-track">
        {loop.map((it, i) => (
          <span key={i} className="mx-10 inline-flex items-center gap-10">
            <span className="font-display text-3xl italic text-bone/90 md:text-5xl">{it}</span>
            <span className="text-kinetic">★</span>
          </span>
        ))}
      </div>
    </div>
  );
}
